module.exports = __webpack_public_path__ + "img/charity_youtube.ca6d67e6.png";